import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://voknbpgkjaabhqhhfihr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZva25icGdramFhYmhxaGhmaWhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg2NTQ2MzEsImV4cCI6MjA3NDIzMDYzMX0.u-8mYkp3Ns_8PvOL9TC5-L2xbUihKFojQ7rFByJo7Qw";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});